import React from 'react'
import { Text } from '@leverege/ui-elements'

import { useSelector } from 'react-redux'

function Component( { variant } ) {
  const { subscriptionInfo } = useSelector( state => state.ui )
  
  return <Text variant={variant || 'detailValue'}>{subscriptionInfo?.valid === true ? 'Valid' : '-'}</Text>
}

export default {
  objectType : 'boat',
  attrName : 'Subscription Status',
  renderer : ( value, valueStyle, object, context, options ) => React.createElement( Component, { variant: options.valueVariant } )
} 
